module.exports = {"search":{"search":"搜索","graph":"概念知识图","network":"网络分析","directions":"未来研究方向","connections":"发现新联系","analysis":"概念共现分析","conclusion":"知识结论","more":"更多","communityA":"社 区 分 析","conceptA":"概 念 分 析","connectionA":"链 接 分 析","abstract":"检索文章摘要","llm":"llm响应","rag":"RAG响应","noData":"暂无数据","title":"标题","description":"描述","explanation":"解释"},"header":{"signIn":"登录"}}


//////////////////
// WEBPACK FOOTER
// ./static/cn.json
// module id = 49fB
// module chunks = 2